// PromptAI Pro plans as shown on /promptai-pro. Display only: the amount
// actually charged comes from the Nohaya Billing service
// (NohayaBilling/app/promptai_plans.py), which only accepts the plan id.
// Keep these labels/prices in sync with it and with the PromptAI app's
// lib/utils/constants.dart.

export type PromptAiPlanId = "single" | "month" | "half_year" | "year";

export type PromptAiPlan = {
  id: PromptAiPlanId;
  title: string;
  price: number; // rupees
  note: string;
  badge?: "Popular" | "Best value";
};

export const SINGLE_PROMPT_PLAN: PromptAiPlan = {
  id: "single",
  title: "Only this prompt",
  price: 9,
  note: "Yours forever",
};

export const PASS_PLANS: PromptAiPlan[] = [
  { id: "month", title: "1 Month", price: 99, note: "Every Pro prompt" },
  { id: "half_year", title: "6 Months", price: 499, note: "Every Pro prompt", badge: "Popular" },
  { id: "year", title: "1 Year", price: 999, note: "Every Pro prompt", badge: "Best value" },
];

export function isPromptAiPlanId(value: string | null): value is PromptAiPlanId {
  return value === "single" || value === "month" || value === "half_year" || value === "year";
}

/** /promptai-pro checkout link; with a prompt, `slug` brings the buyer back to it afterwards. */
export function checkoutHref(plan: PromptAiPlanId, prompt?: { id: number; title: string; slug: string }): string {
  const params = new URLSearchParams({ plan });
  if (prompt) {
    params.set("prompt", String(prompt.id));
    params.set("title", prompt.title);
    params.set("slug", prompt.slug);
  }
  return `/promptai-pro?${params.toString()}`;
}
